export default __webpack_public_path__ + "static/media/test1.83fa40ad.png";